<div class="container" *ngIf="!loading && !showPageInstrucoes">

  <div class="professor-container row p-0">
    <div *ngIf="error" class="professor-filter col-md-3 col-xs-12 p-0">
      <div>
        <h1 class="title">{{ 'questionario.titulo' | translate }}</h1>
      </div>
      <div class="subtitle">
        <span>
          {{ 'questionario.subtitulo' | translate }}
        </span>
      </div>
    </div>

    <div *ngIf="mobileViewLista" id="div-lista-professores" class="professor-filter col-sm-12 col-md-12 col-lg-4 col-xs-12 p-0" >
      <div class="header">
        <h1 class="title">{{ 'questionario.titulo' | translate }}</h1>
      </div>

      <div class="row container mini-banner" *ngIf="!erroFormulario">
        <div class="col-2 icone-banner"><i class="far fa-info-circle"></i></div>
        <div class="texto-banner col-10">{{ 'questionario.banner' | translate }}</div>
      </div>

      <div class="subtitle">
        <span>
          {{ 'questionario.subtitulo' | translate }}
        </span>
      </div>

      <nav id="scroll-content">
        <div #a *ngFor="let prof of professores; let profIndex = index" class="card-content">
          <mat-card *ngIf="prof.questoes >= 0" (click)="back(); selectProfessor(profIndex, false); avaliandoProfessor = true" class="card-flex"
            [class.ignoraAvaliacao]="(
                prof.naoPossuiAulaComProfessor || prof.naoSabeAvaliarProfessor
                )"
            [ngClass]="{
                            active: prof.selected,
                            success: prof.questoes === professores[profIndex]?.quesitos?.length
                        }">
            <div class="img-border">
              <img [lazyLoad]="professorService.getImagem(prof.nomeArquivoFoto, 'icone')" alt="Imagem Professor"
                [defaultImage]="'assets/images/default.png'" />
            </div>
            <div class="card-title">
              {{ prof.nomeExibicao | uppercase }}
            </div>
            <div *ngIf="!professores[profIndex].professorFinalizado">
              {{ professores[profIndex].questoes }}/{{professores[profIndex]?.quesitos?.length}}
            </div>
            <div [class.checkWhite]="prof.selected" class="check" *ngIf="professores[profIndex].questoes >= 0 && prof.questoes === professores[profIndex]?.quesitos?.length && professores[profIndex].professorFinalizado">
              <i class="far fa-check-circle"></i>
            </div>
          </mat-card>
        </div>
      </nav>

      <div  class="float-bar" *ngIf="(professoresAvaliados != professores.length)">
        <div class="texto-float">
          <div><span class="numero">{{professoresAvaliados}} {{ 'questionario.de' | translate }} {{professores.length}}</span>
          <br />
          {{ 'questionario.respondidos' | translate }}</div>
          <app-button (click)="finalizarPOA()">{{ 'questionario.finalizar' | translate }}</app-button>
        </div>
      </div>

      <div class="float-bar" [ngClass]="{ isMobile : 'float-bar-mobile'}" *ngIf="(professoresAvaliados === professores.length)">
        <div class="texto-sucesso-float" style="width: auto;">
          <div class="row-float-bar-mensagem">
            <div> <i class="far fa-check-circle"></i></div>
            <div class="primeira-linha"> Todos foram </div>
          </div>
          <div class="texto-sucesso-float">
            <span>avaliados</span>
          </div>

        </div>
        <div class="botao-sucesso-float">
          <app-button (click)="finalizarPOA()">{{ 'questionario.finalizar' | translate }}</app-button>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-8 col-xs-12 p-0" id="questionario-target">
      <app-comentarios *ngIf="comentarioOpen && !error" [tokenAcesso]="aluno.tokenAcesso"
        [quantidadeProfessores]="professores?.length">
      </app-comentarios>

      <div *ngIf="selectedProfessor && !showQuestion" style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 50%;">
        <app-loader></app-loader>
      </div>

      <app-questoes [reavaliado]="reavaliado" (reavaliacaoRequest)="reavaliacaoRequest($event)"
        *ngIf="!error && comentarioOpen === false && questoes && showQuestion && mobileViewForm"
        [questoes]="questoes"
        [professor]="selectedProfessor" [aluno]="aluno" (pularProfessor)="pularProfessor($event)"
        (bloquearProfessorNaoPossuiAula)="bloquearProfessorNaoPossuiAula($event)"
        (bloquearProfessorNaoSabeAvaliar)="bloquearProfessorNaoSabeAvaliar($event)"
        (questaoSelecionadaEmiter)="marcarQuestao($event)" (comentario)="comments()"
        [quantidadeProfessores]="professores.length" [indexProfessorAtual]="getIndexProfessorSelecionado()"
        (exibirListaProfessoresRequest)="exibirListaProfessoresRequest($event)"
        (formularioFeedback) = "formularioFeedback($event)"
        (comentarioFeedback)="reciverFeedback($event)">
      </app-questoes>

      <div *ngIf="error" class="error-container">
        <div *ngIf="error?.code === 'token_invalido_acesso_aluno'">
          <div id="error-message">
            <i class="fa fa-user-slash"></i>
            <strong>Desculpe!</strong>
            <span>{{ error.message }}</span>
          </div>
        </div>

        <div *ngIf="error?.code === 'token_fora_vigencia_acesso_aluno'">
          <div id="error-message">
            <i class="far fa-calendar-times"></i>
            <strong>Lamento!</strong>
            <span>{{ error.message }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div style="display: flex; justify-content: center; margin-top: 2rem;">
  <app-loader *ngIf="loading"></app-loader>
</div>


<app-page-intrucao [tokenAcesso]="aluno.tokenAcesso" (customEvent)="customEventInstructions($event)" *ngIf="!loading && showPageInstrucoes"></app-page-intrucao>